(() => {
    const onRender = (cookieThough) => {
        if (!cookieThough)
            return

        const style = document.createElement('style')

        style.innerHTML = `
            p:empty {
                display: none;
            }

            .ct-banner h1,
            strong {
                font-weight: var(--ct-heading-font-weight);
            }

            .ct-customization-button svg {
                fill: var(--ct-button-svg-fill);
            }

            .ct-button {
                position: relative;
                overflow: hidden;
                padding: var(--ct-button-padding);
                font-weight: var(--ct-heading-font-weight);
                color: var(--ct-button-color);
                background-color: transparent;
                line-height: normal;
                cursor: pointer;
                border-radius: var(--ct-button-radius);
                border: 1px solid transparent;
                appearance: none;
            }

            .ct-button:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                border: var(--ct-button-border);
                z-index: -6;
            }

            .ct-button:after {
                content: '';
                position: absolute;
                top: -1px;
                left: -1px;
                bottom: -1px;
                right: -1px;
                z-index: -5;
                transition: transform .4s;
                transform-origin: right;
                background-color: var(--ct-button);
            }

            .ct-button-secondary {
                padding: var(--ct-button-secondary-padding);
                border: none;
                background: var(--ct-button-secondary);
            }

            .ct-button-secondary:after {
                transform-origin: left;
                transform: scaleX(0);
            }

            .ct-button:hover:after {
                transform: scaleX(0);
            }

            .ct-button-secondary:hover:after {
                transform: scaleX(1);
            }

            .ct-collapse {
                position: relative;
                -ms-overflow-style: none;
                scrollbar-width: 0;
                scrollbar-color: currentColor transparent;
            }

            .ct-option {
                border-color: var(--ct-policy-border);
            }

            .ct-enabled {
                border-color: var(--ct-policy-border);
            }
        `

        cookieThough.shadowRoot
            .appendChild(style)

        cookieThough.classList.add('ready')

        window.CookieThough
            .onPreferencesChanged((e) => window.dataLayer
                && window.dataLayer.push({ event: 'preferences_changed' }))
    }

    const cookieThoughObserver = 'MutationObserver' in window
        && new window.MutationObserver(() => {
            const cookieThough = document.querySelector('.cookie-though')

            if (!cookieThough)
                return

            cookieThoughObserver.disconnect()

            onRender(cookieThough)
        })

    if (cookieThoughObserver)
        cookieThoughObserver
            .observe(document.body, {
                childList: true,
                subtree: true
            })
})()
